import React from 'react';
import { Form } from 'antd';

import * as S from './styles';
import { useCategoryContext } from '../../context';
import type { Element } from '../../../../../../hooks/useGetElements';
import { RosaSubCategoryEnum } from '../../../../constants';

const { useWatch } = Form;

interface ScoreProps {
	notRequiredElementsMapper: Record<string, Element>;
}

export function Score({ notRequiredElementsMapper }: Readonly<ScoreProps>) {
	const { fieldName, elements } = useCategoryContext();

	const duration = useWatch([...fieldName, 'duration']);
	const requiredElementId = useWatch([...fieldName, 'required']);
	const notRequiredElements = useWatch([...fieldName, 'not_required']);

	function calculateScore(): number {
		const requiredScore = getRequiredFieldScore();

		const notRequiredElementsChecked = getCheckedNotRequiredFields();
		const notRequiredTotalScore = sumCheckedNotRequiredFields(notRequiredElementsChecked);

		const durationScore = getDurationResult();

		return requiredScore + notRequiredTotalScore + durationScore;
	}

	function getRequiredFieldScore(): number {
		const element = elements.required.find((element) => element.id === requiredElementId);

		return element?.score ?? 0;
	}

	function getCheckedNotRequiredFields() {
		const notRequiredElementsList = Object.entries(notRequiredElements ?? {});

		const notRequiredElementsSelected = notRequiredElementsList.filter((element) => element[1]);
		return notRequiredElementsSelected;
	}

	function sumCheckedNotRequiredFields(notRequiredElementsSelected: [string, unknown][]) {
		return notRequiredElementsSelected.reduce((total, currentItem) => {
			const elementScore = notRequiredElementsMapper[currentItem[0]]?.score;

			return total + elementScore;
		}, 0);
	}

	function getDurationResult() {
		if (!duration || fieldName[fieldName.length - 1] === RosaSubCategoryEnum.SEAT_BACKREST) {
			return 0;
		}
		return duration;
	}

	return (
		<S.Container>
			<span>{calculateScore()}</span>
		</S.Container>
	);
}
